/**
 * Returns a support URL with instructions for allowing pop-ups, matched to the
 * caller's actual device and browser — not just desktop Chrome/Firefox/Safari/Edge.
 * iPadOS 13+ reports a desktop Safari user agent, so iPad is also detected via
 * multi-touch support on a "Macintosh" UA.
 */
export const getAllowPopupsUrl = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua) || (ua.includes("macintosh") && navigator.maxTouchPoints > 1);
  const isAndroid = ua.includes("android");

  if (isIOS) {
    if (ua.includes("crios")) return "https://support.google.com/chrome/answer/95472?co=GENIE.Platform%3DiOS";
    if (ua.includes("edgios")) return "https://support.microsoft.com/en-us/microsoft-edge/block-pop-ups-in-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5";
    return "https://support.apple.com/guide/iphone/block-pop-ups-ipha49a83ae8/ios";
  }

  if (isAndroid) {
    if (ua.includes("edg")) return "https://support.microsoft.com/en-us/microsoft-edge/block-pop-ups-in-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5";
    if (ua.includes("firefox")) return "https://support.mozilla.org/en-US/kb/pop-blocker-settings-exceptions-troubleshooting";
    return "https://support.google.com/chrome/answer/95472?co=GENIE.Platform%3DAndroid";
  }

  if (ua.includes("edg")) return "https://support.microsoft.com/en-us/microsoft-edge/block-pop-ups-in-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5";
  if (ua.includes("firefox")) return "https://support.mozilla.org/en-US/kb/pop-blocker-settings-exceptions-troubleshooting";
  if (ua.includes("safari") && !ua.includes("chrome")) return "https://support.apple.com/guide/safari/block-pop-ups-sfri40696/mac";
  return "https://support.google.com/chrome/answer/95472";
};
